import type { VetCustomPlanType } from '@farmersdog/lead-browser-storage';

import { RecipeCard } from '../RecipeCard/RecipeCard';

import type { PetRecipesQuery } from '../../../../graphql/types';

interface RecipeCardListProps {
  recipes: PetRecipesQuery['petRecipes'];
  onChangeSelection?: (recipe: string) => void;
  currentPetRecipeSelection: string[];
  onClickSeeDetails: (recipe: string) => void;
  isVetCustomizedPlanForCurrentPet: boolean;
  vetCustomizedPlan: VetCustomPlanType;
}

const getBadgeCopy = (
  isVetCustomizedPlanForCurrentPet: boolean,
  vetCustomizedPlan: VetCustomPlanType,
  recipe: PetRecipesQuery['petRecipes'][number]
) => {
  const vetPlanBadgeCopy =
    isVetCustomizedPlanForCurrentPet &&
    vetCustomizedPlan?.freshRecipeNames?.includes(recipe.name)
      ? 'Vet Pick'
      : undefined;
  const recommendedBadgeCopy = recipe.recommended ? 'Our Pick' : undefined;
  const badgeCopy = isVetCustomizedPlanForCurrentPet
    ? vetPlanBadgeCopy
    : recommendedBadgeCopy;

  return badgeCopy;
};

export const RecipeCardList = ({
  recipes,
  onChangeSelection,
  currentPetRecipeSelection,
  onClickSeeDetails,
  isVetCustomizedPlanForCurrentPet,
  vetCustomizedPlan,
}: RecipeCardListProps) => {
  return recipes.map(recipe => {
    const badgeCopy = getBadgeCopy(
      isVetCustomizedPlanForCurrentPet,
      vetCustomizedPlan,
      recipe
    );

    return (
      <RecipeCard
        key={recipe.name}
        recipe={recipe}
        onChangeSelection={onChangeSelection}
        currentPetRecipeSelection={currentPetRecipeSelection}
        onClickSeeDetails={onClickSeeDetails}
        badgeCopy={badgeCopy}
      />
    );
  });
};
